module.exports = __webpack_public_path__ + "xplora-logo.png?0038427e699a583223e7ddac6f4ccf2a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xplora-logo.png
// module id = 11
// module chunks = 24